import _ from "lodash"
import { forwardRef, useState } from "react"
import { View, TouchableOpacity, StyleSheet } from "react-native"
import RNPopover, { PopoverPlacement } from 'react-native-popover-view';

const Popover = forwardRef(({ children, anchor, style }, ref) => {

    const [ isOpen, setIsOpen ] = useState(false);

    return (
        <View
            style={[ styles.container, style ]}>

            <RNPopover
                placement={ PopoverPlacement.TOP }
                animationConfig={{
                    duration: 100,
                }}
                popoverStyle={styles.popoverMinWidth300}
                onRequestClose={ setIsOpen.bind( this, false )}
                isVisible={ isOpen }
                from={ (sourceRef, showPopover) => {
                    return (
                        <TouchableOpacity
                            onPress={ setIsOpen.bind( this, true )}>

                            { _.isFunction(anchor) ? anchor() : anchor }

                            <View style={ styles.buttonOverlay }></View>
                        </TouchableOpacity>
                    );
                }}>

                { children }
            </RNPopover>
        </View>
    )
})

const styles = StyleSheet.create({
	popoverMinWidth300: {
		minWidth: 300,
	},
    buttonOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1000,
        // backgroundColor: 'red',
    },

    container: {
		width: 'auto',
		justifyContent: 'flex-end',
		alignSelf: 'flex-end',
    }
})

export default Popover
